import { Injectable } from '@angular/core';
import {EventBusService} from "../../event-bus.service";

@Injectable({
  providedIn: 'root'
})
export class LoadingIndicatorService {
  private activeHttpRequestCount: number;
  constructor(private eventBusService: EventBusService) {
    this.activeHttpRequestCount = 0;
  }

  public showLoader(): void {
    this.activeHttpRequestCount++;
    this.publishEventUpdate('open');
  }

  public hideLoader(): void {
    this.activeHttpRequestCount--;
    this.publishEventUpdate('close');
  }

  private publishEventUpdate(eventType: string): void {
    this.eventBusService.publish('api:loadingIndicator', {
      activeRequestCount: this.activeHttpRequestCount,
      eventType: eventType
    })
  }
}
